"use strict";

//Swiper settings
const swiper = new Swiper('.swiper', {
	loop: false,
	slidesPerView: 1.2,
	spaceBetween: 20,
	breakpoints: {
			500: {
			slidesPerView: 2.3,
			spaceBetween: 10
			},
			750: {
			slidesPerView: 3.5,
			spaceBetween: 20
			}
	},
	navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
	}
})

document.querySelector('.swiper-container').style.margin = 0